import type {
  SectionValue,
  SessionActionsSection as SessionActionsData,
} from "../../../../shared/analysis-types";
import { SectionHeader } from "./section-header";
import { LabeledBody } from "./labeled-body";
import { SectionErrorFallback } from "./section-error-fallback";
import { RetentionCallout } from "./retention-callout";
import { CopyFormattedButton } from "@/components/copy-formatted-button";
import { formatSessionActionsCopy } from "@/lib/analysis-copy-format";
import { getSessionActionCategoryLabel } from "@/lib/analysis-display";

interface SessionActionsSectionProps {
  data: SectionValue<SessionActionsData>;
  className?: string;
}

export function SessionActionsSection({
  data,
  className,
}: SessionActionsSectionProps) {
  if ("error" in data) {
    return (
      <div className={className}>
        <SectionHeader title="Session Actions" />
        <div className="mt-4">
          <SectionErrorFallback sectionName="session_actions" />
        </div>
      </div>
    );
  }

  const { actions, retention } = data;
  const retentionAtTop =
    retention &&
    (retention.status === "absent" || retention.status === "unconfirmed");
  const retentionAtBottom = retention && retention.status === "confirmed";

  return (
    <div className={className}>
      <SectionHeader
        title="Session Actions"
        action={
          <CopyFormattedButton format={formatSessionActionsCopy(data)}>
            Copy section
          </CopyFormattedButton>
        }
      />
      <div className="mt-4 flex flex-col gap-4">
        {retentionAtTop && <RetentionCallout retention={retention} />}

        {actions.map((action, i) => (
          <LabeledBody key={i} label={getSessionActionCategoryLabel(action.category)}>
            {action.text}
          </LabeledBody>
        ))}

        {retentionAtBottom && <RetentionCallout retention={retention} />}
      </div>
    </div>
  );
}
